<div class="content">
    <span class="title">{{property.value | propertyFieldValue}}</span>
    <div class="header">
        <p class="name">{{ property.name ? property.name : getFieldNameOfVariable(property.value)}}</p>
        <div class="btn-actions">
            <button type="button" mat-icon-button (click)="onDelete()">
                <mat-icon>delete</mat-icon>
            </button>
            <button type="button" mat-icon-button (click)="openDialog()">
                <mat-icon>settings</mat-icon>
            </button>
        </div>
    </div>
</div>
